export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/8e8641da5546a83267ff7cb844712535.svg";